import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PdWebState = {
  showPdWeb: boolean;
  pdWebResult: any;
  measured: boolean | null;
  error?: boolean;
};

const initialState: PdWebState = {
  showPdWeb: false,
  pdWebResult: null,
  measured: null,
  error: false,
};

const PdWebSlice = createSlice({
  name: 'pdWeb',
  initialState: initialState,
  reducers: {
    setShowPdWeb: (state, { payload }: PayloadAction<boolean>) => {
      state.showPdWeb = payload;
    },
    setPdWebResult: (state, { payload }) => {
      state.pdWebResult = payload;
    },
    setPdWebMeasuered: (state, { payload }: PayloadAction<boolean | null>) => {
      state.measured = payload;
    },
    setPDWebError: (state, { payload }: PayloadAction<boolean>) => {
      state.error = payload;
    },
  },
});

export const pdWebReducer = PdWebSlice.reducer;
export const pdWebActions = PdWebSlice.actions;
